import React from "react";
import "./dropdown.css";
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
// import Modalsetting from "../modalsetting/modalsetting";
// import { useState } from "react";
function DropdownM({ title, icon, listdata, link, manage, log, Logout, File }) {
  // const [showManage, setshowManage] = useState(false);
  // const [showFile, setshowFile] = useState(false);
  // const [showSub, setshowSub] = useState(false);
  // const [showPayment, setshowPayment] = useState(false);

  // const handleCloseshowManage = () => setshowManage(false);
  // const handleShowshowManage = () => setshowManage(true);

  // const handleCloseshowFile = () => setshowFile(false);
  // const handleShowshowFile = () => setshowFile(true);

  // const handleCloseshowSub = () => setshowSub(false);
  // const handleShowshowSub = () => setshowSub(true);

  // const handleCloseshowPayment = () => setshowPayment(false);
  // const handleShowshowPayment = () => setshowPayment(true);
  let navegate = useNavigate();

  const handleModal = (idx) => {
    if (idx === 0) {
      navegate("/user/manageholiday");
    } else if (idx === 1) {
      navegate("/user/managerequest");
    }
    if (idx === 2) {
      navegate("/user/mainads");
    }
    if (idx === 3) {
      navegate("/user/warnlaw");
    }
    if (idx === 4) {
      navegate("/user/paperdo");
    }
    if (idx === 5) {
      navegate("/user/companywork");
    }
    if (idx === 6) {
      navegate("/user/companyupdate");
    }
    if (idx === 7) {
      navegate("/user/meetings");
    }
    if (idx === 8) {
      navegate("/user/legantan");
    }
    if (idx === 9) {
      navegate("/user/data");
    }
    if (idx === 10) {
      navegate("/user/sub");
    }
    // if (idx === 11) {
    //   navegate ( "/user/supuser")
    // }
    if (idx === 11) {
      navegate("/user/notifications");
    }
  };
  return (
    <React.Fragment>
      {" "}
      <Dropdown>
        <Dropdown.Toggle variant="success" id="dropdown-basic">
          {icon} {title}
        </Dropdown.Toggle>

        {listdata && listdata.length > 0
          ? listdata.map((item, idx) => {
              return (
                <Dropdown.Menu key={idx}>
                  {manage === "manage" ? (
                    <Dropdown.Item
                      // href={idx === 0 ? link : null}
                      onClick={() => handleModal(idx)}>
                      {item}
                    </Dropdown.Item>
                  ) : (
                    <Dropdown.Item>
                      <Link to={link}>{item}</Link>
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              );
            })
          : null}
        {File && File.length > 0
          ? File.map((item, idx) => {
              return (
                <Dropdown.Menu key={idx}>
                  <Dropdown.Item href={`/user/main/${item.id}`}>
                    {item.name}
                  </Dropdown.Item>
                </Dropdown.Menu>
              );
            })
          : null}
      </Dropdown>
      {/* <Modalsetting
        showManage={showManage}
        showFile={showFile}
        showSub={showSub}
        showPayment={showPayment}
        handleCloseshowManage={handleCloseshowManage}
        handleCloseshowFile={handleCloseshowFile}
        handleCloseshowSub={handleCloseshowSub}
        handleCloseshowPayment={handleCloseshowPayment}
      /> */}
    </React.Fragment>
  );
}

export default DropdownM;
